import styled, { css } from 'styled-components'

const Container = styled.div`
  flex-grow: 1;
  flex-basis: 0;
`

const MediaGalleryGridWrapper = styled.div`
  display: none;

  // Show media grid when product is a made to order type on desktop
  @media only screen and (min-width: ${props => props.theme.size.breakpoint['min-width'].md}) {
    display: block;
  }
`

const GalleryModalWrapper = styled.div`
  display: ${props => (props.isModal ? 'block' : 'none')};
`

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  // Hide the carousel when product is a made to order type on desktop
  @media only screen and (min-width: ${props => props.theme.size.breakpoint['min-width'].md}) {
    display: ${props => props.showMediaGalleryGrid && 'none'};
  }

  ${props =>
    props.isPortrait &&
    css`
      flex-direction: row-reverse;
    `}
`
const ImageWrapper = styled.div`
  position: relative;
  padding: 100% 0 0;
  width: 100%;
  height: 100%;
  cursor: zoom-in;

  @media only screen and (min-width: ${props => props.theme.size.breakpoint['min-width'].md}) {
    cursor: ${props => props.showMediaGalleryGrid && !props.isInModal && 'pointer'};
  }

  ${props =>
    props.mainImageZoomed &&
    css`
      cursor: zoom-out;
    `}

  ${props =>
    props.isTranslucent &&
    css`
      opacity: 0.3;
    `}

  @media only screen and (min-width: ${props => props.theme.size.breakpoint['min-width'].md}) {
    padding: ${props => (props.showMediaGalleryGrid ? '100% 0 0' : '59% 0px 0px')};
  }

  picture {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  ${props =>
    props.isPortrait &&
    css`
      padding: ${props.showMediaGalleryGrid ? '100% 0 0' : '135% 0px 0px'};
      @media only screen and (min-width: ${props.theme.size.breakpoint['min-width'].md}) {
        padding: ${props.showMediaGalleryGrid ? '100% 0 0' : '135% 0px 0px'};
      }
    `}

  img,
  .react-transform-component,
  .react-transform-element {
    width: auto;
    height: auto;
    display: block;
    max-width: 100%;
    max-height: 100%;
    position: ${props => (props.isInModal ? 'relative' : 'absolute')};
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    object-fit: contain;
  }

`

const SliderWrapper = styled.div`
  width: 100%;
  flex: 1 0 0;
  display: block;
  position: relative;

  .ac-slider__inner {
    align-items: center;
  }

  .ac-slider__nav {
    width: 100%;
    position: absolute;
    top: 50%;
    pointer-events: none;
    margin-top: -10px;

    &-chevron {
      :first-of-type {
        left: 10px;
      }
      display: flex;
      justify-content: center;
      align-content: center;
      pointer-events: auto;
      margin: 0;
      position: absolute;
      width: 35px;
      height: 35px;
      border: 1px solid ${props => props.theme.color.monochrome.light};
      background: rgba(255, 255, 255, 0.5);
      color: ${props => props.theme.color.monochrome.darker};
      right: 10px;

      svg {
        flex-shrink: 0;
      }
    }
  }

  ${props =>
    css`
      @media only screen and (min-width: ${props.theme.size.breakpoint['min-width'].sm}) {
        flex: 0 0 auto;
        display: flex;
        flex-direction: column;
      }
    `}
`

const ZoomIconWrapper = styled.div`
  cursor: pointer;
  margin: 5px;
  width: 35px;
  height: 35px;
  border-radius: 35px;
  background: rgba(255, 255, 255, 0.5);
  border: 1px solid ${props => props.theme.color.monochrome.light};
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 0;
  bottom: 20px;
`

const Nav = styled.div`
  font-family: ${props => props.theme.font.family.base};
  font-size: 14px;
  line-height: 18px;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${props => props.theme.color.monochrome.dark};
  height: 20px;
  width: 100%;
  background: ${props => props.theme.color.monochrome.lighter};
`

const ThumbnailWrapper = styled.div`
  width: 100%;

  ${props =>
    props.isPortrait &&
    css`
      display: block;
      position: relative;

      @media only screen and (min-width: ${props.theme.size.breakpoint['min-width'].md}) {
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
      }
    `}
`

const MainImage = styled.img`
  position: relative;
  user-select: none;
  cursor: zoom-in;
  width: 100%;
  height: 100%;
  outline: none;

  ${props =>
    props.isMobileLoading &&
    css`
      display: none;
    `}

  ${props =>
    props.isLoading &&
    css`
      @media only screen and (min-width: ${props.theme.size.breakpoint['min-width'].sm}) {
        padding: 70px 0 60px 0;
      }
    `}
`

const MediaIconWrapper = styled.div`
  position: absolute;
  pointer-events: none;
`

export {
  Container,
  Wrapper,
  ImageWrapper,
  SliderWrapper,
  ZoomIconWrapper,
  Nav,
  ThumbnailWrapper,
  MainImage,
  MediaGalleryGridWrapper,
  MediaIconWrapper,
  GalleryModalWrapper
}
